var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPropertyCategory = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 37,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M15.106 35.594h5.312v-5.438h-5.312z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M9.977 35.594h15.569V4.687L9.976 1v6.982"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCAA1",
  d: "M22.405 22.434h-7.3v4.01h7.3zM22.405 14.996h-7.3v4.01h7.3zM22.405 7.563h-7.3v4.01h7.3zM8.667 30.926h6.438v-16.88H8.668z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M15.106 35.593H2.229V10.03l12.877-3.05zM32.59 8.914h-7.043v26.679h7.043zM1 35.594h32.817"
})));
export default SvgPropertyCategory;